let createTimeIDCounterforsafety = 0

export default {
    beforeCreate() {
        if (!this.$options.dynamicComponent) {
            this.$options.dynamicComponent = false
        }

        if (!this.$options.componentIdentifier) {
            let dateid = new Date()
            let id = "el_" + Date.UTC(dateid.getFullYear(), dateid.getMonth(), dateid.getDate(), dateid.getHours(), dateid.getMinutes(), dateid.getSeconds(), dateid.getMilliseconds()) + '_' + (createTimeIDCounterforsafety++)

            this.$options.componentIdentifier = id
            this.$options.newComponent = true

            if (this.$options.schema) {
                this.$store.dispatch('createComponent', { id: id, config: this.$options.schema })
            }
        }
    },
    mounted () {
        let identifier = this.$options.componentIdentifier

        if (identifier && this.$options.newComponent) {
            this.$el.setAttribute('id', identifier)
        }
    },
    computed: {
        $componentData() {
            if (!this.$options.componentIdentifier) {
                return {}
            }

            return this.$store.getters.getComponentData(this.$options.componentIdentifier)
        },
    }
}